import { render } from "./RiBadgeNew.vue?vue&type=template&id=60e9b14a"
import script from "./RiBadgeNew.vue?vue&type=script&lang=js"
export * from "./RiBadgeNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiBadgeNew.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60e9b14a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60e9b14a', __exports__)) {
    api.reload('60e9b14a', __exports__)
  }
  
  module.hot.accept("./RiBadgeNew.vue?vue&type=template&id=60e9b14a", () => {
    api.rerender('60e9b14a', render)
  })

}


export default __exports__